import React, { Component } from 'react'
import App from "./components/App.jsx";
import SearchProvider from './context/context.jsx'

export default () => {

    return (
      <SearchProvider>
        <App />
      </SearchProvider>
    )
};